import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { DataTable, PageActions } from '../../../../fgs';
import DefaultPageContext from '../../../../fgs/context/DefaultPageContext';
import { toolbarActions } from '../utils';
import { setupToolbarActions } from "../componentFunctions";
import { resourceHeaders } from "../../../formHeaders";
import ModalContext from '../../../../fgs/context/ModalContext';
import * as Feather from 'react-feather';

// services
import { getUserResources, deleteResources } from '../../../../services/api';
import { setUrlParams, retrieveDefaultParams } from '../../../../services/urlParams';
import { resourceCategoryMapper } from '../../../../services/selectOptions';
import RequestContext from '../../../../fgs/context/RequestContext';

const UserResourcesPage = () => {
  const history = useHistory();
  const { id } = useParams();
  const { search } = useLocation();
  const requestContext = useContext(RequestContext);
  const permission = requestContext.loggedUser?.permissions?.find(p => p.page === 'UserResourcesPage') || [];
  const [datasource, setDatasource] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);

  const toggleAdvancedFilter = () => setShowAdvancedFilter(!showAdvancedFilter);
  const onRowClick = (resourceId) => { history.push(`/dashboard/user/${id}/resources/${resourceId}/`) };

  const fetchResources = async (context) => {
    setUrlParams.bind({ history, search })({ ...context });
    getUserResources(id).then((response) => {
      response.data.data.forEach(resource => {
        resource.attributes.category = resourceCategoryMapper[resource.attributes.category];
      });
      setDatasource(response.data);
    });
  };

  const doDeleteResources = async (userId, ids) => {
    if(!ids) return;

    deleteResources(userId, ids).then(() => {
      setSelectedItems([]);
      fetchResources(retrieveDefaultParams.bind({ search })());
    });
  };

  useEffect(() => {
    fetchResources(retrieveDefaultParams.bind({ search })());
  }, []);

  const pageTableSetup = {
    header: {
      actionCol: {
        classes: 'sm-action-data'
      },
      tr: {}
    },
    body: {
      actionCol: {
        classes: 'sm-action-data',
        actions: [
          { 
            props: { onClick: (e) => doDeleteResources(id, [e.target.id]) }, 
            icon: Feather.Trash,
            permission: 'remove'
          }
        ].filter(act => permission.actions.some(action => (act.permission === action) || action === 'all'))
      },
      tr: { customClass: 'default-action-row' }
    }
  };

  const providerValues = {
    setSelectedItems,
    selectedItems
  };

  const setupParams = {
    history,
    context: useContext(ModalContext),
    doDeleteResources,
    selectedItems,
    setSelectedItems,
    toggleAdvancedFilter,
    userId: id
  };
  setupToolbarActions(setupParams);

  return (
    <DefaultPageContext.Provider value={providerValues}>
      <DataTable
        showAdvancedFilter={showAdvancedFilter}
        datasource={datasource}
        headers={resourceHeaders}
        onRowClick={onRowClick}
        pageActions={{ component: PageActions, actions: toolbarActions }}
        updateDatasource={fetchResources}
        customTableSetup={pageTableSetup} />
    </DefaultPageContext.Provider>
  );
};

export default UserResourcesPage;